import { CURRENCYCONFIG, type ReceiveCurrencyType } from 'BreetHelpers';

export const getReceiveCurrencyLabel = (currency?: ReceiveCurrencyType): string => {
	if (!currency) return '';
	if (currency === 'card') return 'Card';
	if (currency === 'usd') return 'USD';

	const upperCaseCurrency = currency.toUpperCase() as keyof typeof CURRENCYCONFIG;

	return CURRENCYCONFIG[upperCaseCurrency].currencyShort;
};
